'use strict';

var RecommendationBenchmarkPanelDirective = function RecommendationBenchmarkPanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    controller: 'RecommendationBenchmarkPanelController',
    template: require('../templates/recommendation-benchmark-panel.html'),
    scope: {
      screenState: '=',
      dataDimension: '=dimension'
    }
  };
};
RecommendationBenchmarkPanelDirective.$inject = [];
module.exports = RecommendationBenchmarkPanelDirective;